var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5 text-center text-muted"},[_c('div',{staticClass:"spinner-border text-warning",attrs:{"role":"status"}},[_c('span',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.$t('common.loading')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }